export default function AttachRecommendationReportDirective() {
  return {
    template: require('./attach-recommendation-report.html'),
    scope: {
      recommendationId: '=',
      serviceId: '=',
      reportId: '=',
      report: '=',
    },
    controller: 'AttachRecommendationReportController',
    controllerAs: 'attachRecommendationReportVM',
    bindToController: true,
    replace: true
  };
}
